import { Navigate, useLocation } from 'react-router-dom';
import _ from 'lodash';
import { useAppStore } from '../../stores';
import { callLogoutApi } from '../../modules/Dashboard/services';

interface iProps {
  children: React.ReactNode;
  redirectRoute?: string;
  module?: string;
}

const PrivateRoute: React.FC<iProps> = (props) => {
  const location = useLocation();
  const permissions = useAppStore((state) => state.user.permissions);
  const authenticated = useAppStore((state) => state.authentication.isLoginSuccess);
  const refreshToken = useAppStore((state) => state.user.refreshToken);
  const resetStore = useAppStore((state) => state.resetStore);

  const checkPermissions = () => {
    if (props.module && props.module !== 'Contact') {
      if (props.module === 'Home') {
        const permissionsList = Object.values(permissions) as Array<{ name?: string }>;
        const hasPresidentOrDesigneeOrAdmin = _.find(permissionsList, (p) => {
          return p.name && (p.name.indexOf('AffiliatePresident') >= 0 || p.name.indexOf('Designee') >= 0 || p.name.indexOf('Admin') >= 0 || p.name.indexOf('StateFed') >= 0);
        });
        return !!hasPresidentOrDesigneeOrAdmin;
      }

      const permissionsList = Object.values(permissions) as Array<{ name?: string }>;
      const match = _.find(permissionsList, (p) => {
        return p.name && p.name.indexOf(props.module!) >= 0;
      });
      if (match) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  };

  const { children, redirectRoute = 'landing' } = props;

  if (authenticated) {
    if (
      window.sessionStorage.getItem('loggedIn') !== 'true' &&
      window.sessionStorage.getItem('isCleared') !== 'true'
    ) {
      localStorage.clear();
      callLogoutApi(refreshToken);
      resetStore();
      window.sessionStorage.setItem('isCleared', 'true');
      return <Navigate to={'/' + redirectRoute} state={{ from: location }} replace />;
    }
    if (checkPermissions()) {
      return <>{children}</>;
    } else {
      return <Navigate to="/not-authorized" replace />;
    }
  } else {
    return <Navigate to={'/' + redirectRoute} state={{ from: location }} replace />;
  }
};

export default PrivateRoute;
